/**
 * @file Provides a object with functions to create a share URL for various
 * social services.
 * @module shareURLFactory
 *
 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
 * @version 1.0
 *
 * @example
 * import {shareURLFactory} from '@ta-interaktiv/share-url-factory';
 *
 * let twitterUrl = shareURLFactory['twitter'](
 * {
 *   url: 'http://interaktiv.tagesanzeiger.ch/2017/grossartiges-werk',
 *   via: 'tagesanzeiger',
 *   title: 'Schaut euch diese grossartige Grafik an!',
 *   hashtags: ['TAGrafik', 'awesome']
 * });
 *
 * let facebookUrl = shareURLFactory['facebook'](
 * {
 *   url: 'http://interaktiv.tagesanzeiger.ch/2017/grossartiges-werk',
 *   facebook_id: 123, // Facebook App ID, doesn't work without it.
 *   hashtags: ['TAGrafik'] // Also as an array, but will only use the first
 *                          // item.
 * });
 */
export { default as shareURLFactory } from './shareURLFactory';
export { shareURLFactory as default } from './shareURLFactory';